import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {TrackingContext} from '@homeaway/react-event-tracking';
import {SVGIcon} from '@homeaway/react-svg';
import {INVITE__24} from '@homeaway/svg-defs';

import {namedEvents, linkLocations} from '../../utils/edap';
import {edapTrigger as edapTriggerUtil} from '../../utils/triggerEdap';

const signUpRE = /(def%26service%3D){1}(.*\.com)?.*/;

const redirectHandler = (url) => window.location.assign(url);

function SignUp({
    items,
    travelerLoginClickHandler,
    signUpLabel,
    travelerSignupClickHandler,
}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);

    // if there are no links then render nothing
    if (!items) {
        return null;
    }

    const edapTrigger = () => {
        const field = {
            actionlocation: linkLocations.HEADER_LINK_SIGNUP
        };
        context.trigger(namedEvents.HEADER_LINK_CLICK, field);
        edapTriggerUtil(namedEvents.CTA_SELECTED, {action_location: field.actionlocation, event_action: namedEvents.CTA_HEADER_TAB_CLICKED});
    };

    const getSignupData = (signup) => {
        return signup.find((item) => item.cssClass.includes('traveler'));
    };

    function createSignupHandler(item) {
        return (event) => {
            if (!item.link) {
                return;
            }
            edapTrigger(item);

            let doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

            // if login, perform specific link update
            let newLink = item.link.replace(
                signUpRE,
                `$1${doubleEncodedURI}&kmsi=true`
            );

            // Use of travelerLoginClickHandler for registration button should be discouraged. We allow it here for compatibility.
            const handler =
                travelerSignupClickHandler ||
                travelerLoginClickHandler ||
                newLink !== item.link && redirectHandler;

            if (handler) {
                event.stopPropagation();
                event.preventDefault();

                handler(newLink);
                return;
            }
        };
    }

    const signUp = getSignupData(items);

    return (
        <a className="site-header-nav__link" data-bypass="true" href={signUp.link} onClick={createSignupHandler(signUp)} rel="nofollow">
            <div className="site-header-nav__signup">
                <SVGIcon inlineFlex markup={INVITE__24}/><span className="site-header-nav__icon-label">{signUpLabel}</span>
            </div>
        </a>
    );
}

SignUp.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape),
    travelerLoginClickHandler: PropTypes.func,
    signUpLabel: PropTypes.string,
    travelerSignupClickHandler: PropTypes.func,
};

export {SignUp};
